import React from 'react';
import { Button as ButtonAntd } from 'antd';
import cn from 'classnames';
import { ReactComponent as IconLoading } from 'static/icons/loading.svg';
import { ButtonProps } from './types';
import './style.scss';

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  type = 'primary',
  loading,
  disabled,
  ...props
}) => (
  <ButtonAntd
    className={cn('button', { loading, 'no-text': !children }, className)}
    type={type}
    disabled={disabled || loading}
    {...props}
  >
    {children}
    {loading && (
      <div className="icon-loading">
        <IconLoading />
      </div>
    )}
  </ButtonAntd>
);
